<template>
  <div class="profit">
    <v-container class="pt-6">
      <div class="table wrapper">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="選擇日期"
              prepend-icon="calendar_today"
              readonly
              v-bind="attrs"
              v-on="on"
              class="date-picker"
              hide-details
              color="pink"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates"
            no-title
            scrollable
            range
            color="pink"
            @change="dates.length == 2 ? menu = false : ''"
          ></v-date-picker>
        </v-menu>
        <v-row class="table-header">
          <v-col>項目</v-col>
          <v-col>數量</v-col>
          <v-col>總桃子</v-col>
        </v-row>
        <v-row class="table-content" v-if="value != 'all'" v-for="(item, value) in statistic.types">
          <v-col>{{ $product_types.find(type => type.value == value).text }}</v-col>
          <v-col>{{ item.sold_out }}</v-col>
          <v-col>
            <div class="peach"></div>
            {{ item.sold_peaches }}
          </v-col>
        </v-row>
        <v-row class="table-content headline pink--text font-weight-bold mt-4" v-if="statistic.types && statistic.types.all">
          <v-col>總計</v-col>
          <v-col>{{ statistic.types.all.sold_out }}</v-col>
          <v-col class="text-end flex-grow-1">
            <div class="peach"></div>
            {{ statistic.types.all.sold_peaches }}
          </v-col>
        </v-row>
      </div>
      <v-btn text color="pink" to="/portal/contribution">
        粉絲貢獻排行榜
        <v-icon>chevron_right</v-icon>
      </v-btn><br>
      <v-btn text color="pink" to="/portal/profit/monthly">
        每月收益
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      dates: [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')],
      statistic: {}
    }
  },
  computed: {
    dateRangeText() {
      return this.dates.join(' - ')
    },
  },
  watch: {
    dates(newValue) {
      if(newValue.length == 2) {
        if(this.$moment(newValue[0]).isAfter(newValue[1])) {
          this.dates = newValue.reverse()
        }
        else {
          this.getStatistic()
        }
      }
    }
  },
  created() {
    this.getStatistic()
  },
  methods: {
    getStatistic() {
      this.axios(`/portal/statistics?start=${this.dates[0]}&end=${this.$moment(this.dates[1]).add(1, 'days').format('YYYY-MM-DD')}`).then(response => {
        let all_sold_out = Object.values(response.data.types).reduce((prev, type) => {
          return prev + parseInt(type.sold_out)
        }, 0)
        let all_sold_peaches = Object.values(response.data.types).reduce((prev, type) => {
          return prev + parseInt(type.sold_peaches)
        }, 0)
        response.data.types.all = {sold_out: all_sold_out, sold_peaches: all_sold_peaches}
        this.statistic = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.profit {
  .table {
    .date-picker {
      padding: 16px;
      max-width: 300px;
    }
    .col {
      overflow: unset;
    }
  }
}
</style>